export default "/shape_3026_0.2b829a51-2b1f3a.png";